import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { shape, string } from 'prop-types';
import { captureException } from '@playbookux/playbook-web-core';
import { useHistory } from 'react-router-dom';
import Devices from '../../../core/constants/device-types';
import WrongDevices from '../../../core/constants/wrong-device-types';
import {
  Button,
  Container,
  ErrorMessage,
  Loader,
  MessageContainer,
  Text,
  Title,
} from './styles';
import { getPublicTestSessionById } from './graphql';

const ModeratedTestLink = ({ location }) => {
  const [displayError, setDisplayError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentDevice, setCurrentDevice] = useState('');
  const [correctDevice, setCorrectDevice] = useState('');
  const [meetingUrlTester, setMeetingUrlTester] = useState('');

  const history = useHistory();

  const { 'test-session': testSessionId } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const detectDevice = () => {
    const { userAgent, maxTouchPoints } = navigator;

    if (/Mobile|iPhone|Phone|Android.*Mobile/.test(userAgent)) return Devices.SMARTPHONE;

    if (/iPad|Tablet|Android(?!.*Mobile)/.test(userAgent)
      || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) {
      return Devices.TABLET;
    }

    if (/Macintosh|Windows NT/.test(userAgent)) return Devices.COMPUTER;

    return Devices.COMPUTER;
  };

  // On mount, fetch public test session data.
  useEffect(() => {
    const initializeSession = async () => {
      try {
        const detectedDevice = detectDevice();
        setCurrentDevice(detectedDevice);

        const publicData = await getPublicTestSessionById(testSessionId);
        const requiredDevice = publicData.tester.segment.device;
        setCorrectDevice(requiredDevice);
        setMeetingUrlTester(publicData.meetingUrlTester);

        if (detectedDevice !== requiredDevice) {
          setLoading(false);
          return;
        }
      } catch (err) {
        captureException('INITIALIZE_DETECT_DEVICE_SESSION_ERROR', err);
        history.push('/');
      }
      setLoading(false);
    };

    initializeSession();
  }, [testSessionId, history]);

  const handleJoinMeeting = () => {
    if (currentDevice !== correctDevice) {
      setDisplayError(true);
      return;
    }
    if (meetingUrlTester) {
      window.open(meetingUrlTester, '_blank');
    }
  };

  return (
    <Container>
      <MessageContainer>
        {loading && <Loader />}
        {!loading && (
          <>
            {correctDevice !== currentDevice ? (
              <>
                <Title>You&apos;re using the wrong device!</Title>
                <Text>
                  This is a
                  {' '}
                  {correctDevice}
                  {' '}
                  study, not a
                  {' '}
                  {WrongDevices[correctDevice]}
                  {' '}
                  study.
                </Text>
                <Text>
                  Please paste this link in a browser on your
                  {' '}
                  {correctDevice}
                  {' '}
                  and click &quot;Join Meeting&quot;.
                </Text>
              </>
            ) : (
              <>
                <Title>Join Meeting</Title>
                <Text>Click &quot;Join Meeting&quot; to enter the session 5 minutes before the scheduled start time.</Text>
              </>
            )}
            {displayError && (
              <ErrorMessage>
                You can&apos;t join the meeting from a
                {' '}
                {currentDevice}
                . Please join from a
                {' '}
                {correctDevice}
                .
              </ErrorMessage>
            )}
            <Button onClick={handleJoinMeeting} disabled={displayError}>Join Meeting</Button>
          </>
        )}
      </MessageContainer>
    </Container>
  );
};

ModeratedTestLink.propTypes = {
  location: shape({
    search: string,
  }).isRequired,
};

export default ModeratedTestLink;
